import { RootState } from 'store/rootReducer'

export const getSession = (state: RootState) => state.session
